
import { mergeMap, tap, filter, switchMap, map } from 'rxjs/operators'
import { combineEpics } from 'redux-observable'
import { Epic } from 'interfaces/middleware'
import { remote } from 'helpers/mobileAppHelpers'
import { fromEvent, EMPTY } from 'rxjs'
import { Communication } from 'tangle-shared'
import { setPushNotificationsPlayerIdActionCreator } from 'actions/pushNotificationsActions'
import { INSIGHT_CTA_CLICK } from 'actions/insightsActions'
import { byType } from 'rxOperators/byType'

const pushNotificationsPlayerIdEpic: Epic = () => remote.init$.pipe(
  switchMap(() => fromEvent<Communication.SetPushNotificationsPlayerIdEventPayload>(remote, 'set-push-notifications-player-id')),
  map(setPushNotificationsPlayerIdActionCreator))

const acceptPushInsightEpic: Epic = (action$) => action$
  .pipe(byType(INSIGHT_CTA_CLICK)).pipe(
    filter((action) => action.payload.type === 'allow_push_notifications'),
    tap(() => remote.promptPushNotificationsPermissions()),
    mergeMap(() => EMPTY))

export const webviewEpic = combineEpics(
  pushNotificationsPlayerIdEpic,
  acceptPushInsightEpic,
)
